import { useParams } from "react-router-dom";

import { usePermissions } from "~/shared/context/PermissionContext";

export const useCardEditAccess = () => {
  const { id } = useParams<{ id: string }>();
  const isAdd = id === "add";
  const { hasPermission } = usePermissions();

  const canEditAll =
    isAdd || hasPermission("employeeAccounting.employee.card.edit.all");
  const canEditAny =
    canEditAll ||
    hasPermission("employeeAccounting.employee.card.edit.partial");

  return { canEditAll, canEditAny };
};
